import Base from './Base';
import CrmUsers from '../collections/CrmUsers';

export default class UserIntegration extends Base {
    constructor(item) {
        super(item);

        this.crm_users = new CrmUsers(this.crm_users).models;
    }
}
